import { FormRowLayout } from '@/app/pages/my_account/components/form_layouts'
import { PaymentDetail } from '@/schemas/payments.schema'
import { useTranslation } from 'react-i18next'
import { currencyFormatter } from '../../utilities'
import { Card, CardContent, CardHeader } from '../Card'
import { FormRowLabel, FormRowValue } from '../FormRow'
import { getTotalAmountToBePaidByApplicant } from '../../payment.utils'
import { getTotalServiceFeeToBePaidByApplicant } from '../../utils/payment/utils'
import { TransactionDetails } from '@/apis/transactions/transaction_detail.schema'

type Props = {
  payment: PaymentDetail | TransactionDetails
}

export default function PaymentAmountCard(props: Props) {
  const { t } = useTranslation()
  const { payment } = props

  const isApplicantPayingServiceFee = payment.service_fee_payer === 'Applicant'

  return (
    <Card className="h-content">
      <CardHeader>
        <h2 className="text-lg font-bold">Amounts</h2>
      </CardHeader>
      <CardContent>
        <div className="">
          <FormRowLayout>
            <FormRowLabel text="Payment Amount" />
            <FormRowValue
              text={currencyFormatter.format(
                getTotalAmountToBePaidByApplicant({
                  base_amount: payment.amount_provider,
                  net_amount: payment.total_amount,
                  service_fee: payment.service_fee,
                  serviceFeePayer: payment.service_fee_payer,
                })
              )}
            />
          </FormRowLayout>
          {isApplicantPayingServiceFee && (
            <FormRowLayout>
              <FormRowLabel text="Service Fee" />
              <FormRowValue
                text={currencyFormatter.format(
                  getTotalServiceFeeToBePaidByApplicant(
                    payment.service_fee,
                    payment.service_fee_payer
                  )
                )}
              />
            </FormRowLayout>
          )}
          {payment.type !== 'Reimbursement' && (
            <FormRowLayout>
              <FormRowLabel text={t('amount_to_provider')} />
              <FormRowValue
                text={currencyFormatter.format(payment.amount_provider)}
              />
            </FormRowLayout>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
